export default __webpack_public_path__ + "static/media/logo-text-large.60af9f1a.svg";